module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-container"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_vm._v("每月客户增长趋势")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择年度"
    },
    on: {
      "change": _vm.updateChart
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  }, _vm._l((_vm.yearOptions), function(year) {
    return _c('el-option', {
      key: year,
      attrs: {
        "label": (year + "年度"),
        "value": year
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.loading) ? _c('el-loading', [_vm._v("加载中...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "customer-trend-chart"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34028f37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/mydateCustomer.vue
// module id = 1002
// module chunks = 3